export const generateDoseLevelLabel = (
    dose: { displayMaxDoseGy: number; generated: boolean } | undefined,
    doseScale: number,
    relativeDoseInPercent?: number
): string | null => {
    if (!dose || !relativeDoseInPercent) {
        return null;
    }

    const maxDosePercentage = relativeDoseInPercent.toFixed(0);
    const maxDoseGy = dose.displayMaxDoseGy.toFixed(1);
    const doseRescaledByValue =
        doseScale !== 1 ? (((doseScale - 1) / 1) * 100).toFixed() : null;

    return dose.generated &&
        doseRescaledByValue &&
        parseFloat(doseRescaledByValue) !== 0
        ? `Max: ${maxDosePercentage} % (${maxDoseGy} Gy, scaled by ${doseRescaledByValue} %)`
        : `Max: ${maxDosePercentage} % (${maxDoseGy} Gy)`;
};
